/* eslint-disable accessor-pairs */

const E_HTTP_BAD_GATEWAY = 502;
const E_HTTP_SERVICE_UNAVAILABLE = 503;
const E_HTTP_GATEWAY_TIMEOUT = 504;

/**
 * @implements {$ZAPI.Error.ZAPIError}
 */
export class ZAPIError extends Error {
    name = 'ZAPIError';

    /**
     * @param {ErrorInfo} errorInfo
     */
    constructor(errorInfo) {
        super(`${errorInfo.request.endpointID} failed with code ${errorInfo.code}`);

        /**
         * @type {$ZAPI.Error.ErrorCode}
         */
        this.code = errorInfo.code;

        this.status = errorInfo.status;
        this.request = errorInfo.request;
        this.response = errorInfo.response;
    }
}

/**
 * @param {number} status
 * @returns {boolean}
 */
export const isHttp50XError = (status) => {
    return (
        status === E_HTTP_BAD_GATEWAY ||
        status === E_HTTP_SERVICE_UNAVAILABLE ||
        status === E_HTTP_GATEWAY_TIMEOUT
    );
};

/**
 * @param {unknown} error
 * @returns {error is ZAPIError}
 */
export const isZAPIError = (error) => {
    return error instanceof ZAPIError;
};

export * from './enums/index.js';

/**
 * @typedef {import('../../__internal__/http-client/interfaces').HttpRequestInfo} HttpRequestInfo
 * @typedef {import('./interfaces').ZAPIError} IZAPIError
 */

/**
 * @typedef {Object} ErrorInfo
 * @prop {$ZAPI.Error.ErrorCode} code
 * @prop {number} status
 * @prop {HttpRequestInfo} request
 * @prop {$ZAPI.Response.ErrorResponse} [response]
 */
